document.addEventListener("DOMContentLoaded", () => {

    const button = document.querySelector(".login-about-toggle");
    const content = document.querySelector(".login-about-collapse");

    if (!button || !content) return;

    button.addEventListener("click", () => {

        content.classList.toggle("active");

        if (content.classList.contains("active")) {

    button.textContent = "Read Less...";
    document.querySelector(".login-about-content").classList.add("expanded");

} else {

    button.textContent = "Read More...";
    document.querySelector(".login-about-content").classList.remove("expanded");

    content.closest(".login-about").scrollIntoView({
        behavior: "smooth",
        block: "start"
    });

}

    });

});